import React from "react";

const Java_tan = () => {
  return (
    <div>
      <h1>Java tan</h1>
      <p>This page provides explanations, examples, and common use-cases for Java tan in Java.</p>
    </div>
  );
};

export default Java_tan;
